import React, { useContext } from 'react';
import { Box, Text, Flex, Menu, Stack, Group, Tooltip } from '@mantine/core';
import { IconCaretDown } from '@tabler/icons';
import IdeaContext from '../../IdeaContext';
import PerspectiveList from './PerspectiveList';
import DiscoveryContext from '../../../Discovery/DiscoveryContext';
import { usePerspectives } from '../../../../hooks/useCustomizations';

interface EnhancedBusinessSourcesProps {
  ideaPage: boolean;
}

const EnhancedBusinessSources: React.FC<EnhancedBusinessSourcesProps> = ({ 
  ideaPage 
}) => {
  const ContextToUse: React.Context<any> = 
    ideaPage ? IdeaContext : DiscoveryContext;

  const {
    type,
    setType,
    perspectiveData
  } = useContext(ContextToUse);

  // Get current perspectives for the dropdown
  const { data: currentPerspectives } = usePerspectives();
  const perspectiveConfigurations = currentPerspectives?.data || [];

  return (
    <Stack pl={38} pr={85.4} align='stretch'>
      <Box mb={ideaPage ? 16 : 0} mt={26} py={2}>
        <Flex>
          <Text fz="14px" fw={600} mr='4px'>
            Perspective:
          </Text>
        
          <Menu 
            position='bottom' 
            withinPortal
            width={260}
            closeOnClickOutside={true}
            closeOnItemClick={true}
            withArrow
            shadow='md'
          >
            <Menu.Target>
              <Flex sx={{cursor: 'pointer'}}>
                <Text fz="14px" mr='4px'>
                  {perspectiveConfigurations?.find((i: any) => i.key == type)?.label}
                </Text>
                <IconCaretDown fill='black' size={14}/>
              </Flex>
            </Menu.Target>
            <Menu.Dropdown>
              {perspectiveConfigurations?.map((perspective: any) => {
                const perspData = perspectiveData[perspective.key];
                const totalCount = (perspData?.requestsCount || 0) + (perspData?.matchesCount || 0) + (perspData?.inboxCount || 0);
                const hasData = perspData?.dataArr?.length > 0;
                
                return (
                  <Tooltip
                    key={perspective.key}
                    label={!hasData ? `No evidence with ${perspective.label}` : ""}
                    position="bottom"
                    withArrow
                    disabled={hasData}
                  >
                    <Box>
                      <Menu.Item
                        onClick={() => {
                          setType(perspective.key);
                        }}
                        disabled={!hasData}
                        sx={(theme) => ({
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          opacity: hasData ? 1 : 0.5,
                          '&[data-disabled]': {
                            color: theme.colors.gray[6],
                            cursor: 'not-allowed'
                          }
                        })}
                      >
                        <Group position='apart' w="100%">
                          <Text>{perspective.label}</Text>
                          <Text size="xs" color={hasData ? "#9F9AF8" : "gray.6"} fw={600}>
                            {totalCount}
                          </Text>
                        </Group>
                      </Menu.Item>
                    </Box>
                  </Tooltip>
                );
              })}
              
              {/* {!showAddForm && (
                <Box>
                  <Button
                    variant='subtle'
                    size='xs'
                    leftIcon={<IconPlus size={14} />}
                    fullWidth
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleAddNewClick();
                    }}
                  >
                      Add New
                  </Button>
                </Box>
              )}

              {showAddForm && (
                <Group spacing={0} position='apart' mt={4}>
                  <ActionIcon
                    size="sm"
                    variant="subtle"
                    onClick={handleCancel}
                    disabled={updatePerspectives.isPending}
                  >
                    <IconX size={14} />
                  </ActionIcon>

                  <Select
                    placeholder="Select base"
                    data={availableOptions}
                    value={selectedAvailablePerspective}
                    onChange={handleAvailablePerspectiveChange}
                    disabled={loadingAvailable || updatePerspectives.isPending}
                    searchable
                    clearable
                    size="xs"
                    style={{ width: 100 }}
                  />

                  <TextInput
                    placeholder="Label"
                    value={perspectiveLabel}
                    onChange={(e) => {
                      setPerspectiveLabel(e.target.value);
                      // Auto-generate key from label
                      setPerspectiveKey(e.target.value.toLowerCase().replace(/[^a-z0-9]/g, ''));
                    }}
                    disabled={updatePerspectives.isPending}
                    size="xs"
                    style={{ width: 100 }}
                  />

                  <ActionIcon
                    size="sm"
                    variant="filled"
                    onClick={handleSave}
                    loading={updatePerspectives.isPending}
                    disabled={
                      !perspectiveLabel.trim()
                    }
                  >
                    <IconCheck size={14} />
                  </ActionIcon>
                </Group>
              )} */}
            </Menu.Dropdown>
          </Menu>  
        </Flex>   
      </Box>
      <PerspectiveList ideaPage={ideaPage}/>
    </Stack>
  );
};

export default EnhancedBusinessSources; 